import axios from 'axios';
import { showTabs, selectTab } from '../../common/tab/tabActions';
import consts from '../../consts';
import { setErroAPI, setSuccess } from '../../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../../common/dateFormat/DateFormat';
import FormatUtils from '../../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'CHECKLIST_PERGUNTAS_MODO_TELA',
        payload: {
			modo: modo,
			registro: {
				...registro

			}
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('checklistPerguntasForm', {
			...registro


		})
    ];
}

export function setAguardando(aguardando) {
    return {
        type: 'CHECKLIST_PERGUNTAS_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista(id_checklist) {
    const request = axios.get(`${consts.API_URL}/checklistPerguntas?id_checklist=${id_checklist}`);
    return {
        type: 'CHECKLIST_PERGUNTAS_LISTADO',
        payload: request
    };
}


export function salvar(registro) {

    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/checklistPerguntas`, {
				...registro,
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_checklist));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/checklistPerguntas`, {
				...registro,

			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_checklist));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function salvarOrdenacao(listaOrdenar = []) {

    return async (dispatch, getState) => {

			if (listaOrdenar && listaOrdenar.length > 0) {

				for (var i = 0; i < listaOrdenar.length; i++) {
					let pergunta = listaOrdenar[i];

					await axios.put(`${consts.API_URL}/checklistPerguntas`, {
						...pergunta,
						ordem: i+1
					}).then(resp => {
					}).catch(e => {
						setErroAPI(e);
					});
				}

				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(listaOrdenar[0].id_checklist));
				dispatch(setModoTela('lista'));

			}
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/checklistPerguntas?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(registro.id_checklist));
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaChecklist() {
    const request = axios.get(`${consts.API_URL}/checklist/listarSelect`);
    return {
        type: 'CHECKLIST_PERGUNTAS_CHECKLIST_LISTADO',
        payload: request
    };
}

export function getListaSetor() {
    const request = axios.get(`${consts.API_URL}/setor/listarSelect`);
    return {
        type: 'CHECKLIST_PERGUNTAS_SETOR_SELECT_LISTADO',
        payload: request
    };
}
